import { Injectable } from '@angular/core';

@Injectable()
export class PDFService {

    private pdf: any;

    constructor(){  }

    set(pdf: any) {
        this.pdf = pdf;
    }

    get(){
        return this.pdf;
    }

}


// WEBPACK FOOTER //
// ./src/services/pdf.service.ts